/**
 * AMCパスワード入力画面
 *
 */
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SupportModalIdComponent } from '@lib/components/support-class';
import { CommonLibService, PageInitService } from '@lib/services';
import { PasswordInputService } from './password-input.service';
import { GetBasicReservationInformationRequest } from 'src/sdk-amcmember';
import { GetBasicReservationInformationStoreService } from '@lib/services/get-basic-reservation-information-store/get-basic-reservation-information-store.service';
import { PageType } from '@lib/interfaces';

@Component({
  selector: 'asw-password-input',
  templateUrl: './password-input.component.html',
  providers: [PasswordInputService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PasswordInputComponent extends SupportModalIdComponent {
  override autoInitEnd = false;

  amcNumber: string = '';

  subPageId: string = 'M081';
  subFunctionId: string = 'R01';
  public password: string = '';
  public passwordFormControl = new FormControl();

  constructor(
    private readonly _common: CommonLibService,
    private readonly _pageInitService: PageInitService,
    private readonly _service: PasswordInputService,
    private readonly _getBasicReservationInformationStoreService: GetBasicReservationInformationStoreService
  ) {
    super(_common, _pageInitService);
    this._common.aswCommonStoreService.updateAswCommon({
      subFunctionId: this.subFunctionId,
      subPageId: this.subPageId,
    });
  }

  init() {
    this.amcNumber = this._common.amcMemberStoreService.amcMemberData.amcNumber;
    if (this.amcNumber.length > 4) {
      this.amcNumber = '*'.repeat(this.amcNumber.length - 4) + this.amcNumber.slice(-4);
    }
    this._pageInitService.subDynamicInit(this.params);
    this._pageInitService.endInit(null);
  }

  reload() {
    /* override abstract reload function of base class */
  }

  clickLogin() {
    this.password = this.passwordFormControl.value;
    if (this._service.checkPassword(this.password)) {
      return;
    }
    const requestParameter: GetBasicReservationInformationRequest = {
      password: this.password,
    };
    this._service.getBasicReservationInformation(requestParameter);
    this.subscribeService(
      'getBasicReservationInformationStoreService',
      this._getBasicReservationInformationStoreService.getGetBasicReservationInformation$(),
      (response) => {
        if (!response.isPending) {
          if (response.isFailure && this._common.apiError) {
            this._common.errorsHandlerService.setRetryableError(PageType.SUBPAGE, { errorMsgId: 'E0227' });
          } else {
            this.close(true);
          }
        }
      }
    );
  }

  destroy() {
    /* override abstract destroy function of base class */
  }
}
